import React, { useState, useEffect } from 'react';
import './otp.css';
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { verifyOTP } from "../../../context/Slice/loginSlice";

const AdminAuthentication = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { email} = location.state;

  const [OTP, setOTP] = useState(new Array(6).fill(''));
  const [timer, setTimer] = useState(40);
  const [isResendEnabled, setIsResendEnabled] = useState(false);

  useEffect(() => {
    const countdown = setInterval(() => {
      if (timer > 0) {
        setTimer(timer - 1);
      } else {
        setIsResendEnabled(true);
        clearInterval(countdown);
      }
    }, 1000);
    return () => clearInterval(countdown); // Cleanup on unmount
  }, [timer]);

  const handleOtpChange = (element, index) => {
    const value = element.value.replace(/\D/g, ''); // Only allow digits
    if (value.length <= 1) {
      let newOTP = [...OTP];
      newOTP[index] = value;
      setOTP(newOTP);

      // Focus on the next input field if available
      if (value !== '' && index < OTP.length - 1) {
        element.nextElementSibling.focus();
      }

      // Focus on the previous input field if the current one is emptied
      if (value === '' && index > 0) {
        element.previousElementSibling.focus();
      }
    }
  };

  const handleResendOtp = () => {
    // Implement logic to resend OTP (e.g., call an API endpoint)
    setIsResendEnabled(false);
    setTimer(60); // Reset timer
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const enteredOTP = OTP.join('');
   
    if (enteredOTP.length === 6) {
      const response = await dispatch(verifyOTP({ email:email, otp: enteredOTP }));
      if (response.payload.status === 200) {
        navigate("/login"); 
      } else {
        console.log("Something went wrong ");
      }
    } else {
 
      console.log('Incorrect OTP entered.');
    }
  };

  const handleCancel = () => {
    // Implement logic to handle cancellation (e.g., redirect to login page)
    console.log('OTP verification cancelled.');
    // Redirect or perform another action upon cancellation
  };

  return (
    <div className='otp-container'>
      <form onSubmit={handleSubmit} className="otp-verification-form">
        <img src="/assets/Images/logo.png" alt="Logo" className="otp-logo" />
        <h2 className="otp-heading">Please check your email</h2>
        <p className="otp-description">
          We've sent a code to {email}.
        </p>
        <div className="otp-digits">
          {OTP.map((digit, index) => (
            <input
              key={index}
              type="text"
              maxLength={1}
              value={digit}
              onChange={(e) => handleOtpChange(e.target, index)}
              className="otp-digit"
            />
          ))}
        </div>
        <div className="otp-timer-container">
          {timer > 0 ? (
            <span className="otp-timer">Resend code in {timer} seconds</span>
          ) : (
            <button
              type="button"
              disabled={!isResendEnabled}
              onClick={handleResendOtp}
              className="otp-resend"
            >
              Resend Code
            </button>
          )}
        </div>
        <div className="otp-buttons">
          <button type="submit" className="otp-submit">
            Verify
          </button>
          <button type="button" onClick={handleCancel} className="otp-cancel">
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default AdminAuthentication;
